
import { FormHelperText, TextField, useFormControl } from "@mui/material";
import { useMemo, useState } from "react";
import * as Yup from "yup";
import { requiredText } from "../../utils/helpers";


export const ImportSchema = Yup.object().shape({
  age: Yup.string()
    .required(requiredText("Age")),
  fatherName: Yup.string()
    .required(requiredText("Father's Name")),
  fullName: Yup.string()
    .required(requiredText('Full Name')),
  roomNo: Yup.string()
    .required(requiredText('Room Number')),
  serialNo: Yup.string()
    .required(requiredText('Serial Number')),
  sex: Yup.string()
    .required(requiredText('Gener')),
});

export const TextInput = (props) => {

  return <TextField color="secondary" {...props}
    variant="standard"
    size="small"
    sx={{
      '& .MuiFormHelperText-root': {
        margin: 0
      },
      '& .MuiFormLabel-root[data-shrink="true"]': {
        color: 'var(--bg-blue)'
      },
      '& .MuiInputBase-root::after': {
        borderColor: 'var(--bg-blue)'
      },
    }}
  />

}

export const FormHelperTextWrapper = ({ formik, name }) => {
  const { focused, ...rest } = useFormControl() || {};

  const [color, setColor] = useState('inherit')

  const helperText = useMemo(() => {

    if (formik.errors[name]) {
      setColor('var(--form-error)')
      return formik.errors[name];
    }

    return '';
  }, [formik]);

  return <FormHelperText
    sx={{
      marginTop: 0,
      marginLeft: 0,
      color
    }}
  >{helperText}</FormHelperText>;
}